"use client";

import Link from "next/link";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const NAV_LINKS = [
  { href: "#how", label: "How it works" },
  { href: "#actions", label: "Actions" },
  { href: "#privacy", label: "Privacy" },
  { href: "#pricing", label: "Pricing" },
];

const MOBILE_NAV_ID = "mobile-nav";

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/60 bg-background/75 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 sm:px-8 lg:px-10">
        <Link href="/" className="font-display text-2xl font-extrabold tracking-tight">
          Dobbix
        </Link>

        <nav aria-label="Main navigation" className="hidden items-center gap-8 md:flex">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className="text-sm font-semibold text-muted-foreground transition-colors hover:text-foreground"
            >
              {link.label}
            </Link>
          ))}
          <Link
            href="https://app.dobbix.io"
            className="text-sm font-semibold text-muted-foreground transition-colors hover:text-foreground"
          >
            Log in
          </Link>
          <Button
            asChild
            size="sm"
            className="rounded-xl px-4 shadow-md shadow-primary/20 hover:shadow-lg hover:shadow-primary/25"
          >
            <Link href="https://app.dobbix.io">Start 7-day free trial</Link>
          </Button>
        </nav>

        <button
          type="button"
          className="inline-flex h-10 w-10 items-center justify-center rounded-md md:hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2 focus-visible:ring-offset-background"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={mobileMenuOpen}
          aria-controls={MOBILE_NAV_ID}
        >
          {mobileMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="border-t border-border/60 bg-background px-6 py-4 md:hidden">
          <nav id={MOBILE_NAV_ID} aria-label="Mobile navigation" className="flex flex-col gap-4">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className="text-sm font-semibold text-muted-foreground transition-colors hover:text-foreground"
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <Link
              href="https://app.dobbix.io"
              className="text-sm font-semibold text-muted-foreground transition-colors hover:text-foreground"
              onClick={() => setMobileMenuOpen(false)}
            >
              Log in
            </Link>
            <Button asChild size="sm" className="w-full rounded-xl">
              <Link href="https://app.dobbix.io">Start 7-day free trial</Link>
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
}
